import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';

@Injectable({
	providedIn: 'root'
})
export class UserResourcesService {

	public sessionResources: BehaviorSubject<Array<string>> = new BehaviorSubject([]);
	private sessionId: string;
	private cdsId: string;
	private readonly noSessionValue = "NO_SESSION";
	static endpointEnum = {
		START_SESSION: "/api/v1/redis/startSession",
		GET_SESSION_RESOURCES: "/api/v1/redis/resources"
	}

	constructor(private httpService: HttpService) {
		this.httpService = httpService;
	}

	async setUserResources() {
		if (this.sessionId == this.noSessionValue) {
			this.sessionResources.next(await this.httpService.doGet(`${UserResourcesService.endpointEnum.GET_SESSION_RESOURCES}/${this.cdsId}`));
			this.httpService.setRequestsResources(this.sessionResources.value);
		}
		else {
			this.sessionResources.next(await this.httpService.doGet(`${UserResourcesService.endpointEnum.GET_SESSION_RESOURCES}/${this.cdsId}`));
		}
	}

	async setSession(cdsId: string) {
		if (!cdsId) {
			return;
		}
		try {
			this.cdsId = cdsId;
			let { sessionId } = await this.httpService.doGet(`${UserResourcesService.endpointEnum.START_SESSION}/${this.cdsId}`);
			this.sessionId = sessionId;
			this.httpService.setSessionId(sessionId);
			await this.setUserResources();
		} catch (err) {

		}
	}

	validateResource(resource: UserResourcesEnum): boolean {
		return this.sessionResources.value.includes(resource);
	}

}

@Injectable({ providedIn: "root" })
export class RedisSessionInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let modifiedReq = req.clone();
		if (localStorage.getItem('wingsEncodedAccessToken') != null) {
			modifiedReq = modifiedReq.clone({
				headers: modifiedReq.headers.set("Authorization", 'Bearer ' + localStorage.getItem('wingsEncodedAccessToken'))
			});
		}

		let sessionId = localStorage.getItem("RSESSIONID");
		if (sessionId && req.url.includes("/api/v1/redis/")) {
			modifiedReq = req.clone({
				headers: modifiedReq.headers.set("RSession", sessionId)
			});
			if (sessionId == "NO_SESSION") {
				modifiedReq = req.clone({
					headers: modifiedReq.headers.set("Resources", localStorage.getItem("Resources") ? localStorage.getItem("Resources") : "")
				})
			}
		}

		return next.handle(modifiedReq);
	}
}

export enum UserResourcesEnum {
	SUBDIVISION = "roleXsubdivision",
	DISP_INVOI_CRUD = "dispatchingandinvoicing_crud",
	INVOI_EXPORT_CRUD = "invoice_export_crud"
}
